import { render, staticRenderFns } from "./imageText.vue?vue&type=template&id=0d31042b&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./imageText.vue?vue&type=script&lang=js&"
export * from "./imageText.vue?vue&type=script&lang=js&"
import style0 from "./imageText.scss?vue&type=style&index=0&id=0d31042b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d31042b",
  null
  
)

export default component.exports